import { defaultAddDeviceState } from './const';

const addDeviceAction = {
  initializeState: 'INITIALIZE_STATE',
  resetState: 'RESET_STATE',
  setDefaultState: 'SET_DEFAULT_STATE',
  changeDeviceUid: 'CHANGE_DEVICE_UID',
  changeDeviceName: 'CHANGE_DEVICE_NAME',
  changeSite: 'CHANGE_SITE',
  changeProfile: 'CHANGE_PROFILE',
  changeLicenseKeyList: 'CHANGE_LICENSE_KEY_LIST'
}

const addDeviceReducer = (state, action) => {
  switch (action.type) {
    case addDeviceAction.initializeState:
      return {
        ...state,
        ...action.payload
      };
    case addDeviceAction.resetState:
      return {
        deviceUid: {
          ...state['deviceUid'],
          value: null,
          list: state['deviceUid'].originList,
          dirty: false,
          valid: false
        },
        deviceName: {
          ...state['deviceName'],
          value: '',
          dirty: false,
          valid: false
        },
        site: {
          ...state['site'],
          selected: null,
          restrictCountryCode: ''
        },
        profile: {
          ...state['profile'],
          selected: null,
          list: []
        },
        licenseKeyList: {
          ...state['licenseKeyList'],
          valueList: [],
          list: []
        }
      };
    case addDeviceAction.setDefaultState:
      return {
        ...state,
        ...action.payload
      };
    case addDeviceAction.changeDeviceUid:
      return {
        ...state,
        deviceUid: action.payload
      };
    case addDeviceAction.changeDeviceName:
      return {
        ...state,
        deviceName: action.payload
      };
    case addDeviceAction.changeSite:
      return {
        ...state,
        site: action.payload
      };
    case addDeviceAction.changeProfile:
      return {
        ...state,
        profile: action.payload
      };
    case addDeviceAction.changeLicenseKeyList:
      return {
        ...state,
        licenseKeyList: action.payload
      };
    default:
      return defaultAddDeviceState;
  }
};

export default {
  defaultState: defaultAddDeviceState,
  action: addDeviceAction,
  reducer: addDeviceReducer
}